import { api } from "@/features/utils/fetch-server";
import type {
  EnrichmentRun,
  EnrichmentScope,
  EnrichmentState,
  ProposalSelection,
} from "../types";

const base = (clientId: string) => `/api/enrichment/v1/${clientId}/fast-track`;

export class EnrichmentAPI {
  static getState = async (clientId: string): Promise<EnrichmentState> =>
    api.get<EnrichmentState>(base(clientId));

  /**
   * Start a run. Returns as soon as the job is recorded — progress is read by
   * polling `getState`.
   */
  static start = async (
    clientId: string,
    input: { scopes: EnrichmentScope[]; url?: string },
  ): Promise<EnrichmentRun> => {
    const response = await api.post<
      { run: EnrichmentRun },
      { scopes: EnrichmentScope[]; url?: string }
    >(base(clientId), input);
    return response.run;
  };

  /** Write the ticked items of a run's proposal — the only write there is. */
  static apply = async (
    clientId: string,
    runId: string,
    input: { scope: EnrichmentScope; items: ProposalSelection[] },
  ): Promise<EnrichmentRun> => {
    const response = await api.post<
      { run: EnrichmentRun },
      { scope: EnrichmentScope; items: ProposalSelection[] }
    >(`${base(clientId)}/${runId}/apply`, input);
    return response.run;
  };

  /** Set a scope's proposal (or its failure) aside without writing. */
  static dismiss = async (
    clientId: string,
    runId: string,
    input: { scope: EnrichmentScope },
  ): Promise<EnrichmentRun> => {
    const response = await api.post<
      { run: EnrichmentRun },
      { scope: EnrichmentScope }
    >(`${base(clientId)}/${runId}/dismiss`, input);
    return response.run;
  };
}
